import { useMemo } from 'react';

type FilterableItem = {
  title: string;
  description?: string;
};

/**
 * Filters items based on a search term.
 * Searches in both title and description fields (case-insensitive).
 */
export function useFilteredItems<T extends FilterableItem>(items: T[], filter?: string): T[] {
  return useMemo(() => {
    const term = (filter ?? '').trim().toLowerCase();
    if (!term) return items;

    return items.filter(item => {
      const title = item.title.toLowerCase();
      const desc = (item.description ?? '').toLowerCase();
      return title.includes(term) || desc.includes(term);
    });
  }, [items, filter]);
}
